<button [attr.data-uiid]="dataUiid" mat-flat-button class="chat-button" (click)="onClick()">
    {{ label }}<mat-icon iconPositionEnd fontSet="material-icons-outlined">chat</mat-icon>
</button>
